function parseArchidektUrl(url) {
  try {
    const urlObj = new URL(url);
    const cardList = urlObj.searchParams.get('c');
    if (!cardList) {
      return null;
    }
    
    const cardEntries = cardList.split('||');
    
    const cards = cardEntries.map(entry => {
      const match = entry.match(/^(\d+)\s+(.+)$/);
      if (!match) {
        console.warn(`Could not parse card entry: ${entry}`);
        return null;
      }
      
      const quantity = parseInt(match[1]);
      const cardName = match[2];
      
      const handle = cardName
        .toLowerCase()
        .replace(/[^a-z0-9\s]/g, '')
        .replace(/\s+/g, '-') 
        .replace(/-+/g, '-') 
        .replace(/^-|-$/g, '');
      
      return {
        quantity,
        name: cardName,
        handle
      };
    }).filter(card => card !== null);
    
    return cards;
    
  } catch (error) {
    console.error('Error parsing URL:', error);
    return [];
  }
}
